var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleRounded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1437252865"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.0001 12.7777C25.0001 11.7499 24.915 10.9999 24.7308 10.2222H12.7553V14.861H19.7847C19.643 16.0139 18.8776 17.75 17.1769 18.9166L17.1531 19.0719L20.9396 21.9466L21.2019 21.9722C23.6112 19.7917 25.0001 16.5833 25.0001 12.7777Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.7546 25.0001C16.1984 25.0001 19.0894 23.8889 21.2012 21.9722L17.1762 18.9166C16.0992 19.6527 14.6536 20.1666 12.7546 20.1666C9.38168 20.1666 6.5189 17.986 5.49841 14.9722L5.34883 14.9846L1.41166 17.9708L1.36017 18.111C3.45763 22.1943 7.76598 25.0001 12.7546 25.0001Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.49874 14.9724C5.22948 14.1946 5.07364 13.3612 5.07364 12.5001C5.07364 11.639 5.22948 10.8057 5.48457 10.0279L5.47744 9.86219L1.49092 6.82812L1.36049 6.88893C0.49603 8.58344 0 10.4862 0 12.5001C0 14.514 0.49603 16.4168 1.36049 18.1112L5.49874 14.9724Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.7547 4.83333C15.1497 4.83333 16.7653 5.84721 17.6866 6.69449L21.2863 3.25001C19.0755 1.23612 16.1985 0 12.7547 0C7.76598 0 3.45764 2.80555 1.36017 6.88886L5.48426 10.0278C6.51893 7.01392 9.38168 4.83333 12.7547 4.83333Z",
    fill: "#EB4335"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleRounded);
export default __webpack_public_path__ + "static/media/google-rounded.821590c7499cc26410018f4a0f5578f0.svg";
export { ForwardRef as ReactComponent };